/* eslint-disable prefer-template */

import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import styled from 'styled-components'

const ProgressStyle = styled.div`
  height: 100%;
  margin: 0;
  border-radius: 3px;
  &.uploading {
    background: repeating-linear-gradient(-55deg, #009ae2, #009ae2 25px, #7dcbef 25px, #7dcbef 50px);
    background-size: 61px 200px;
    animation: slide 5s infinite linear forwards;
  }
  &.success {
    background: ${props => props.theme.colors.green};
  }
  &.error {
    background: ${props => props.theme.colors.red};
  }
  @-webkit-keyframes slide {
    0% {
      background-position: 0% 0;
    }
    100% {
      background-position: 100% 0;
    }
  }
  @-moz-keyframes slide {
    0% {
      background-position: 0% 0;
    }
    100% {
      background-position: 100% 0;
    }
  }
  @keyframes slide {
    0% {
      background-position: 0% 0;
    }
    100% {
      background-position: 100% 0;
    }
  }
`

const styles = theme => ({
  progressBar: {
    width: '100%',
    height: '6px',
    marginTop: '6px',
    backgroundColor: theme.colors.midGrey,
    borderRadius: '3px',
  },
})

const Progress = ({ classes, progress, variant }) => {
  return (
    <div className={classes.progressBar}>
      {/* biome-ignore lint/style/useTemplate: TODO */}
      <ProgressStyle className={cn(classes.progress, variant)} style={{ width: progress + '%' }} />
    </div>
  )
}

Progress.defaultProps = {
  progress: 0,
}

const ProgressComponent = withStyles(styles)(Progress)
ProgressComponent.displayName = 'Progress'
export default ProgressComponent
